@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
}

@if (showPropertyType()) {
    <property-type-button></property-type-button>
}
